import React from "react";
// import "./Members.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "./M19.css";
// import { FaFacebookF, FaInstagram, FaLinkedin } from "react-icons/fa";
function M19() {
  return (
    <div>
      <h1 className="h1">Meet Our Team</h1>
      <br />
      <br />
      <h1 className="h1" id="m3">
        2K19
      </h1>
      <br />
      <br />

      <div id="" class="team">
        <div class="container">
          {/* <div class="section-title">
            <h2>Team</h2>
            <h3>
              Our <span>Office-Bearers</span>
            </h3>
            <p>
              Ut possimus qui ut temporibus culpa velit eveniet modi omnis est
              adipisci expedita at voluptas atque vitae autem.
            </p>
          </div> */}

          <div class="row">
            <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
              <div class="member">
                <div class="member-img">
                  <img
                    src="images/2K19/RHR - Copy.jpg"
                    class="img-fluid team_img"
                    alt=""
                  />
                </div>
                <div class="member-info">
                  <h4>Raj Hansh Raj</h4>
                  <span>President</span>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
              <div class="member">
                <div class="member-img">
                  <img
                    src="images/2K19/Anjalikumari1 - Copy.jpg"
                    class="img-fluid team_img"
                    alt=""
                  />
                </div>
                <div class="member-info">
                  <h4>Anjali Kumari</h4>
                  <span>Vice president</span>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
              <div class="member">
                <div class="member-img">
                  <img
                    src="images/2K19/Amit Kumar - Copy.jpg"
                    class="img-fluid team_img"
                    alt=""
                  />
                </div>
                <div class="member-info">
                  <h4>Amit Kumar</h4>
                  <span>Secretary</span>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
              <div class="member">
                <div class="member-img">
                  <img
                    src="images/2K19/Nadeem Rehman Alam - Copy.jpg"
                    class="img-fluid team_img more_pad1"
                    alt=""
                  />
                </div>
                <div class="member-info">
                  <h4>Nadeem Rehman Alam</h4>
                  <span>Joint-secretary</span>
                </div>
              </div>
            </div>
          </div>
          <br />
          <br />
          <div class="row">
            <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
              <div class="member">
                <div class="member-img">
                  <img
                    src="images/2K19/SAGAR MISHRA - Copy.jpg"
                    class="img-fluid team_img"
                    alt=""
                  />
                </div>
                <div class="member-info">
                  <h4>Sagar Mishra</h4>
                  <span>Treasurer</span>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
              <div class="member">
                <div class="member-img">
                  <img
                    src="images/2K19/KHUSHI GROVER - Copy.jpg"
                    class="img-fluid team_img"
                    alt=""
                  />
                </div>
                <div class="member-info">
                  <h4>Khushi Grover</h4>
                  <span>Joint Treasurer</span>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
              <div class="member">
                <div class="member-img">
                  <img
                    src="images/2K19/Dhiraj Pandey - Copy.jpg"
                    class="img-fluid team_img"
                    alt=""
                  />
                </div>
                <div class="member-info">
                  <h4>Dhiraj Pandey</h4>
                  <span>Technical Heads</span>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
              <div class="member">
                <div class="member-img">
                  <img
                    src="images/2K19/Yogesh Kumar (NSS) - Copy.JPG"
                    class="img-fluid team_img"
                    alt=""
                  />
                </div>
                <div class="member-info">
                  <h4>Yogesh Kumar</h4>
                  <span>Technical Heads</span>
                </div>
              </div>
            </div>

            <br />
            <br />
          </div>
          <div class="row">
            <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
              <div class="member">
                <div class="member-img">
                  <img
                    src="images/2K19/Suraj Pramanik - Copy.jpg"
                    class="img-fluid team_img more_pad1"
                    alt=""
                  />
                </div>
                <div class="member-info">
                  <h4>Suraj Kumar Pramanik</h4>
                  <span>Meeting Head</span>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
              <div class="member">
                <div class="member-img">
                  <img
                    src="images/2K19/Binod Murmu - Copy.jpg"
                    class="img-fluid team_img"
                    alt=""
                  />
                </div>
                <div class="member-info">
                  <h4>Binod Murmu</h4>
                  <span>Meeting Head</span>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
              <div class="member">
                <div class="member-img">
                  <img
                    src="images/2K19/Geet Kumar - Copy.jpg"
                    class="img-fluid team_img"
                    alt=""
                  />
                </div>
                <div class="member-info">
                  <h4>Geet Kumar</h4>
                  <span>Program Coordinator</span>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
              <div class="member">
                <div class="member-img">
                  <img
                    src="images/2K19/Rohananand - Copy.jpg"
                    class="img-fluid team_img"
                    alt=""
                  />
                </div>
                <div class="member-info">
                  <h4>Rohan Anand</h4>
                  <span>Program Coordinator</span>
                </div>
              </div>
            </div>

            <br />
            <br />
          </div>
          <div class="row">
            <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
              <div class="member">
                <div class="member-img">
                  <img
                    src="images/2K19/Ajay Kumar - Copy.jpg"
                    class="img-fluid team_img"
                    alt=""
                  />
                </div>
                <div class="member-info">
                  <h4>Ajay Kumar</h4>
                  <span>Program coordinator</span>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
              <div class="member">
                <div class="member-img">
                  <img
                    src="images/2K19/Kumar Sanu - Copy.jpg"
                    class="img-fluid team_img"
                    alt=""
                  />
                </div>
                <div class="member-info">
                  <h4>Kumar Sanu</h4>
                  <span>Program Coordinator</span>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
              <div class="member">
                <div class="member-img">
                  <img
                    src="images/2K19/PavitraBhakat - Copy.jpg"
                    class="img-fluid team_img"
                    alt=""
                  />
                </div>
                <div class="member-info">
                  <h4>Pavitra Kr Bhakat</h4>
                  <span>PRO</span>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
              <div class="member">
                <div class="member-img">
                  <img
                    src="images/2K19/Nikki kumari - Copy.jpg"
                    class="img-fluid team_img"
                    alt=""
                  />
                </div>
                <div class="member-info">
                  <h4>Nikki Kumari</h4>
                  <span>PRO</span>
                </div>
              </div>
            </div>

            <br />
            <br />
          </div>
          <div class="row">
            <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
              <div class="member">
                <div class="member-img">
                  <img
                    src="images/2K19/Shubham Kumar  - Copy.png"
                    class="img-fluid team_img"
                    alt=""
                  />
                </div>
                <div class="member-info">
                  <h4>Shubham Kumar</h4>
                  <span>Alumini Incharge</span>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
              <div class="member">
                <div class="member-img">
                  <img
                    src="images/2K19/Anjali Kumari - Copy.jpg"
                    class="img-fluid team_img"
                    alt=""
                  />
                </div>
                <div class="member-info">
                  <h4>Anjali Kumari</h4>
                  <span>Alumini Incharge</span>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
              <div class="member">
                <div class="member-img">
                  <img
                    src="images/2K19/_Budhram Hembram - Copy.JPG"
                    class="img-fluid team_img more_pad2"
                    alt=""
                  />
                </div>
                <div class="member-info">
                  <h4>Budhram Hembram</h4>
                  <span>Inventory Head</span>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
              <div class="member">
                <div class="member-img">
                  <img
                    src="images/2K19/AkashKr - Copy.jpg"
                    class="img-fluid team_img"
                    alt=""
                  />
                </div>
                <div class="member-info">
                  <h4>Akash Kr Mandal</h4>
                  <span>Inventory Head</span>
                </div>
              </div>
            </div>
          </div>
          <br />
          <br />
          <div class="row">
            <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
              <div class="member">
                <div class="member-img">
                  <img
                    src="images/2K19/Nitish - Copy.jpg"
                    class="img-fluid team_img"
                    alt=""
                  />
                </div>
                <div class="member-info">
                  <h4>Nitish Kumar</h4>
                  <span>Media Head</span>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
              <div class="member">
                <div class="member-img">
                  <img
                    src="images/2K19/Piyush kumar - Copy.jpg"
                    class="img-fluid team_img"
                    alt=""
                  />
                </div>
                <div class="member-info">
                  <h4>Piyush Kumar</h4>
                  <span>Media Head</span>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
              <div class="member">
                <div class="member-img">
                  <img
                    src="images/2K19/Prahul kumar_ - Copy.jpg"
                    class="img-fluid team_img"
                    alt=""
                  />
                </div>
                <div class="member-info">
                  <h4>Prahul Kumar</h4>
                  <span>Planning and Execution Head</span>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
              <div class="member">
                <div class="member-img">
                  <img
                    src="images/2K19/Sunny - Copy.jpg"
                    class="img-fluid team_img more_pad1"
                    alt=""
                  />
                </div>
                <div class="member-info">
                  <h4>Sunny Kumar</h4>
                  <span>Planning and Execution Head</span>
                </div>
              </div>
            </div>
          </div>
          <br />
          <br />
          <div class="row">
            <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
              <div class="member">
                <div class="member-img">
                  <img
                    src="images/2K19/Vicky Kumar Mandal - Copy.jpg"
                    class="img-fluid team_img"
                    alt=""
                  />
                </div>
                <div class="member-info">
                  <h4>Vicky Kumar Mandal</h4>
                  <span>Planning and Execution Head</span>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
              <div class="member">
                <div class="member-img">
                  <img
                    src="images/2K19/RahulRanjan - Copy.jpg"
                    class="img-fluid team_img"
                    alt=""
                  />
                </div>
                <div class="member-info">
                  <h4>Rahul Ranjan</h4>
                  <span>scurvey head</span>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
              <div class="member">
                <div class="member-img">
                  <img
                    src="images/2K19/Harshit Pallove - Copy.jpg"
                    class="img-fluid team_img"
                    alt=""
                  />
                </div>
                <div class="member-info">
                  <h4>Harshit Pallove</h4>
                  <span>Survey Head</span>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
              <div class="member">
                <div class="member-img">
                  <img
                    src="images/2K19/Shivnandan  - Copy.jpg"
                    class="img-fluid team_img"
                    alt=""
                  />
                </div>
                <div class="member-info">
                  <h4>Shivnandan</h4>
                  <span>Scurvey Head</span>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
              <div class="member">
                <div class="member-img">
                  <img
                    src="images/2K19/no - Copy.jpg"
                    class="img-fluid team_img"
                    alt=""
                  />
                </div>
                <div class="member-info">
                  <h4>Shivam Kumar</h4>
                  <span>Survey Head</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />
    </div>
  );
}

export default M19;
